module.exports = __webpack_public_path__ + "static/personal_data_processing_policy-bde0eec0e168800aedd58000c766f2a1.pdf";